import React, { Component } from "react";
import FormCore from "@/components/display/form/formCore";
import GridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { getTaskList, deleteTask } from "@/fetch/fetchApi"; //  executeTask, getStubCfgResult
import moment from "moment";
import { Modal, message } from "antd";
import fetchHandler from "@/fetch/fetchHandler";
import RefreshGrid from "@/utils/refreshGrid";
import TaskSelect from "./taskSelect";
import CfgExport from "./cfgExport";
import TaskExecuteResult from "./taskExecuteResult";
import CfgChangeTaskBuild from "./cfgChangeTaskBuild";

@connect((state) => state)
class taskManagement extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.taskManagement;
    this.init();
    this.state = {
      loading: false,
      visible: false,
      taskInfo: null,
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  handleDisplayExecuteResultBtnClick(e, key) {
    this.taskExecuteResult = e;
    this.taskId = key;
    this.modalVisibleAction("seeTaskExecteResultVisible", true);
  }

  init() {
    this.formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: this.internationalization.placeholder1, // '请输入操作人',
          param: {
            name: "createAccount",
            type: "string",
          },
          labelName: this.internationalization.title1, // '创建人:',
          required: false,
        },
        {
          type: "select",
          options: [
            {
              text: this.internationalization.all, // '全部',
              value: "",
            },
            {
              text: this.internationalization.btn1, // '配置修改',
              value: "0",
            },
            {
              text: this.internationalization.btn2, // '固件升级',
              value: "1",
            },
          ],
          placeholder: this.internationalization.placeholder, // '请选择',
          param: {
            name: "type",
            type: "string",
          },
          labelName: this.internationalization.title11, // '任务类型:',
          required: false,
          defaultValue: "",
        },
        {
          type: "select",
          options: [
            {
              text: this.internationalization.all, // '全部',
              value: "",
            },
            {
              text: this.internationalization.state1, // '未执行',
              value: "0",
            },
            {
              text: this.internationalization.state2, // '已执行',
              value: "1",
            },
          ],
          placeholder: this.internationalization.placeholder, // '请选择',
          param: {
            name: "status",
            type: "string",
          },
          labelName: this.internationalization.title2, // '任务状态:',
          required: false,
          defaultValue: "",
        },
        {
          type: "date",
          dateType: "rangeDate",
          width: "200px",
          placeholder: [
            this.internationalization.placeholder2,
            this.internationalization.placeholder2,
          ],
          param: {
            name: "date",
            type: "array",
          },
          defaultValue: [moment(new Date()).subtract(0, "d"), moment(new Date())],
          validator: {
            // 自定义校验对象
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            // max_val: 7 // 可选最大天数
          },
          labelName: this.internationalization.title3, // '创建时间:',
          required: !1,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              icon: "search",
              text: this.internationalization.btn3, // '查询'
            },
            {
              btnType: "button",
              icon: "plus",
              text: this.internationalization.btn4, // '新建任务',
              handler: () => {
                this.setState({
                  seeTaskSelectVisible: true,
                });
              },
            },
            {
              btnType: "button",
              icon: "button",
              text: this.internationalization.btn5, // '配置导出',
              handler: () => {
                this.setState({
                  seeCfgExportVisible: true,
                });
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !0, // 设置为false不触发加载grid
      context: this,
      tableKey: "taskTable",
    };
    this.tableConfig = {
      tableKey: "taskTable",
      tableColumns: [
        {
          name: this.internationalization.actionSheet, // '操作名称',
          key: "operationName",
          colType: "textCol",
          width: "200px",
        },
        {
          name: this.internationalization.title4, // '创建人',
          key: "createAccount",
          colType: "textCol",
          align: "left",
          width: "200px",
        },
        {
          name: this.internationalization.title5, // '创建时间',
          key: "createTime",
          colType: "textCol",
          width: "200px",
        },
        {
          name: this.internationalization.title6, // '任务类型',
          key: "type",
          colType: "textCol",
          align: "left",
          width: "200px",
          render: (value) => {
            switch (value) {
              case 0:
                return this.internationalization.btn6; // '配置修改';
              case 1:
                return this.internationalization.btn7; // '固件升级';
              default:
                return "--";
            }
          },
        },
        {
          name: this.internationalization.title7, // '操作电桩数量',
          key: "count",
          colType: "textCol",
          align: "center",
        },
        {
          name: this.internationalization.title8, // '任务状态',
          key: "status",
          colType: "textCol",
          align: "left",
          render: (value, row) => {
            switch (value) {
              case 0:
                return this.internationalization.state3; // '未执行';
              case 1:
                return (
                  <a
                    onClick={() => {
                      this.handleDisplayExecuteResultBtnClick(row.operationName, row.key);
                    }}>
                    {this.internationalization.title10}
                  </a>
                );
              default:
                return "--";
            }
          },
        },
        {
          name: this.internationalization.title9, // '备注',
          key: "comments",
          colType: "tipCol",
          align: "left",
          width: "200px",
          tipNum: 20,
        },
        {
          name: this.internationalization.action, // '操作',
          key: "action",
          fix: "right",
          width: 200,
          colType: "action",
          actionMap: [
            // {
            //     type: 'href',
            //     actionName:this.internationalization.btn8 ,// '任务执行',
            //     render: (value, row, index) =>{
            //         switch (row.status) {
            //             case 0: return this.internationalization.btn8 ;// "任务执行";
            //             case 1: return null;
            //             default:return  this.internationalization.btn8 ;// "任务执行";
            //         }
            //     },
            //     handler:(res) => {
            //         fetchHandler(executeTask,{
            //             taskName:res.operationName,
            //             taskId:res.key,
            //             userName:res.createAccount
            //         }).then(result => {
            //             if(result && result.code === "success"){
            //                 message.success( this.internationalization.msg1);
            //                 //刷新表格
            //                 return RefreshGrid(this.context.store, "taskTable");
            //             }
            //         })
            //     }
            // },
            {
              type: "href",
              actionName: this.internationalization.btn9, // '查看任务',
              handler: (res) => {
                this.setState(
                  {
                    taskId: res.key,
                  },
                  () => {
                    this.taskInfo = res;
                    this.modalVisibleAction("seeViewTaskVisible", true);
                  },
                );
              },
            },
            {
              type: "confirm",
              actionName: this.internationalization.btn10, // '删除',
              render: (value, row) => {
                switch (row.status) {
                  case 0:
                    return this.internationalization.btn10; // "删除";
                  case 1:
                    return null;
                  default:
                    return this.internationalization.btn10; // "删除";
                }
              },
              handler: (res) => {
                fetchHandler(deleteTask, {
                  taskName: res.operationName,
                  taskId: res.key,
                }).then((result) => {
                  if (result && result.code === "success") {
                    message.success(this.internationalization.msg1);
                    // 刷新表格
                    return RefreshGrid(this.context.store, "taskTable");
                  }
                });
              },
            },
          ],
        },
      ],
      tableParam: {
        pagecount: 10,
      },
      dataApi: getTaskList,
      autoRefresh: !1, // 设置为true 直接加载grid数据
    };
  }

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  refresh() {
    return RefreshGrid(this.context.store, "taskTable");
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.formConfig} />
        </div>
        <div className="page-panel">
          <GridTable config={this.tableConfig} />
        </div>
        <Modal
          title={this.internationalization.btn11}
          visible={this.state.seeTaskSelectVisible}
          footer={null}
          destroyOnClose
          width="600px"
          onCancel={() => {
            this.modalVisibleAction("seeTaskSelectVisible", false);
          }}>
          <TaskSelect
            addTab={this.props.onAdd}
            onCancel={() => {
              this.modalVisibleAction("seeTaskSelectVisible", false);
            }}
            refreshGrid={() => {
              this.refresh();
            }}
          />
        </Modal>

        <Modal
          title={this.internationalization.btn12}
          visible={this.state.seeCfgExportVisible}
          footer={null}
          destroyOnClose
          width="1000px"
          onCancel={() => {
            this.modalVisibleAction("seeCfgExportVisible", false);
          }}>
          <CfgExport
            refreshGrid={() => {
              RefreshGrid(this.context.store, "taskTable");
            }}
            onCancel={() => {
              this.setState({ seeCfgExportVisible: false });
            }}
          />
        </Modal>

        <Modal
          title={this.internationalization.btn13}
          visible={this.state.seeViewTaskVisible}
          footer={null}
          destroyOnClose
          width="1000px"
          onCancel={() => {
            this.modalVisibleAction("seeViewTaskVisible", false);
          }}>
          <CfgChangeTaskBuild taskInfo={this.taskInfo} isView />
        </Modal>

        <Modal
          title={this.internationalization.btn14}
          visible={this.state.seeTaskExecteResultVisible}
          footer={null}
          destroyOnClose
          width="600px"
          onCancel={() => {
            this.modalVisibleAction("seeTaskExecteResultVisible", false);
          }}>
          <TaskExecuteResult taskId={this.taskId} taskName={this.taskExecuteResult} />
        </Modal>
      </div>
    );

    return Content;
  }
}

export default injectIntl(taskManagement);



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/taskManagement/taskManagement.js